import * as React from 'react';
import { forwardRef } from 'react';

import { FieldFormGroupProps, FieldFormGroup } from '@shared/components/fields/field_form_group';

import { TextAreaFormControlType, TextAreaFormControlProps, TextAreaFormControl } from './text_area_form_control';

export type TextAreaFormGroupType = TextAreaFormControlType;
export type TextAreaFormGroupProps = TextAreaFormControlProps & FieldFormGroupProps;

export const TextAreaFormGroup = forwardRef<TextAreaFormGroupType, TextAreaFormGroupProps>(
  ({ has, help, label, className, ...input }, ref) => (
    <FieldFormGroup has={has} help={help} label={label} className={className} id={input.id}>
      <TextAreaFormControl ref={ref} {...input} />
    </FieldFormGroup>
  ),
);
